export type GpPromotionContextUserStatus = 'registered' | 'provisional'

export interface GpPromotionContext {
  readonly user: {
    readonly id: string
    readonly short_id: string
    readonly status: GpPromotionContextUserStatus
  }
  readonly order: {
    readonly order_times: number
    readonly last_order_date: string | null
  }
  readonly point: {
    readonly total_amount: number
    readonly next_expiring_amount: number | null
    readonly next_expiring_date: string | null
  }
}

export interface GpPromotionContextEvent {
  readonly event: 'gp_promotion_context'
  readonly gp_promotion_context: GpPromotionContext
}

const create = (context: GpPromotionContext): GpPromotionContextEvent => ({
  event: 'gp_promotion_context',
  gp_promotion_context: context,
})

export const gpPromotionContextEventFactory = {
  create,
} as const
